module.exports = __webpack_public_path__ + "img/icon-usuarios.58e27c4c.svg";